import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RouteModeLockStore } from './route-mode-lock.store';

const inspectionLockedReason = 'inspection-locked';

export const rootEntryRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const routeModeLock = inject(RouteModeLockStore);

  if (routeModeLock.isInspectionLocked()) {
    return router.createUrlTree(['/not-found'], {
      queryParams: { reason: inspectionLockedReason },
    });
  }

  return router.createUrlTree(['/workbench']);
};

export const workbenchModeAccessGuard: CanActivateFn = route => {
  const router = inject(Router);
  const routeModeLock = inject(RouteModeLockStore);

  const hasExplicitSessionKey = ['session_key', 'sessionkey']
    .some(queryName => route.queryParamMap.has(queryName));

  if (!routeModeLock.isInspectionLocked() || hasExplicitSessionKey) {
    return true;
  }

  return router.createUrlTree(['/not-found'], {
    queryParams: { reason: inspectionLockedReason },
  });
};
